/* import cuerpo_2018_4cuerpo_25x24 from "./pics/Pagina web/2018/cuerpo/(4)cuerpo(25x24).webp";
import Estudio_de_paisaje_12_IMG_2562_1 from "./pics/Pagina web/2019/Estudio de paisaje 12/IMG_2562 1.webp";
import Estudio_de_paisaje_nocturno_1 from "./pics/Pagina web/2019/Estudio de paisaje nocturno/1.webp";
import Estudio_de_paisajes_a_la_luz_de_la_luna_IMG_2543_1 from "./pics/Pagina web/2019/Estudio de paisajes a la luz de la luna/IMG_2543.webp";
import La_esencia_de_la_materia_Sin_titulo_1 from "./pics/Pagina web/2020/La esencia de la materia/Sin título-1.webp";
import Acumulacion_de_causalidades_IMG_9123 from "./pics/Pagina web/2022/Acumulación de causalidades/IMG_9123.webp";
import Cuando_Miro_Grito_IMG_0756 from "./pics/Pagina web/2023/Cuando Miro Grito/IMG_0756.webp";
import sintro_PICA_1 from "./pics/Pagina web/2023/S.I.N.T.R.O.P.I.C.A/1.webp";
import sintro_PICA_Pintura_Humana_Tierra from "./pics/Pagina web/2023/S.I.N.T.R.O.P.I.C.A/Pintura Humana-Tierra.webp";
import pic2 from "./pics/Pagina web/2023/Cuando Miro Grito/IMG_0748.webp"; */
import Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2070 from "./pics/Pagina web/2024/Muestra de Acciones Multidisciplinarias 2021-2023/IMG_2070.webp";
import Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2073 from "./pics/Pagina web/2024/Muestra de Acciones Multidisciplinarias 2021-2023/IMG_2073.webp";
import Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2080 from "./pics/Pagina web/2024/Muestra de Acciones Multidisciplinarias 2021-2023/IMG_2080.webp";
import Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2123 from "./pics/Pagina web/2024/Muestra de Acciones Multidisciplinarias 2021-2023/IMG_2123.webp";
import Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2188 from "./pics/Pagina web/2024/Muestra de Acciones Multidisciplinarias 2021-2023/IMG_2188.webp";
import Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2191 from "./pics/Pagina web/2024/Muestra de Acciones Multidisciplinarias 2021-2023/IMG_2191.webp";
import Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2193 from "./pics/Pagina web/2024/Muestra de Acciones Multidisciplinarias 2021-2023/IMG_2193.webp";
import Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2194 from "./pics/Pagina web/2024/Muestra de Acciones Multidisciplinarias 2021-2023/IMG_2194.webp";
import Acaricia from "./pics/Pagina web/2024/Proyecto-H-T/pic1.webp";

export let json = [
  {
    name: "Accion purificar la Tierra Limpieza y Reforestacion",
    year: "2024",
    picture: [
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2070,
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2070,
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2073,
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2080,
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2123,
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2188,
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2191,
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2193,
      Muestra_de_Acciones_Multidisciplinarias_2021_2023_IMG_2194,
    ],
  },
  {
    name: "Proyecto Humano-Tierra",
    year: "2021",
    picture: [
      Acaricia,
      Acaricia,
    ],
    description: "Para mas informacion, visita: https://modulattions.wixsite.com/proyecto-humano---ti"
  }
  /* {
    name: "Pintura Humana-Tierra",
    year: "2023",
    picture: [
      sintro_PICA_1,
      sintro_PICA_Pintura_Humana_Tierra
    ]
  },
  {
    name: "Carga generacional",
    year: "2023",
    picture: [
      pic2,
      Cuando_Miro_Grito_IMG_0756,
    ]
  },
  {
    name: "Acumulación de causalidades",
    year: "2022",
    picture: [
      Acumulacion_de_causalidades_IMG_9123
    ]
  },
  {
    name: "Mujer Arbol",
    year: "2020",
    picture: [
    ]
  },
  {
    name: "La esencia de la materia",
    year: "2020",
    picture: [
      La_esencia_de_la_materia_Sin_titulo_1
    ]
  },
  {
    name: "Estudio de paisajes a la luz de la luna",
    year: "2019",
    picture: [
      Estudio_de_paisajes_a_la_luz_de_la_luna_IMG_2543_1
    ]
  },
  {
    name: "Estudio de paisaje nocturno",
    year: "2019",
    picture: [
      Estudio_de_paisaje_nocturno_1
    ]
  },
  {
    name: "Estudio de paisaje 12",
    year: "2019",
    picture: [
      Estudio_de_paisaje_12_IMG_2562_1
    ]
  },
  {
    name: "cuerpo",
    year: "2018",
    picture: [
      cuerpo_2018_4cuerpo_25x24
    ]
  } */
];
